// axios基础的封装
import axios from 'axios';
import { ElMessage, ElLoading } from 'element-plus';
import _ from 'lodash';
import { getDeviceFingerprint } from './fingerprint';

const httpInstance = axios.create({
  baseURL: 'https://app.iprocket.io/prod-api', //  /*生产环境*/
  // baseURL: 'https://app.iprocket.pro/prod-api', //  /*测试环境*/
  // baseURL: 'http://192.168.1.25:9919',//开发环境
  // baseURL: 'http://127.0.0.1:9919/prod-api', // 自动构建测试环境
  // baseURL: 'http://127.0.0.1:9919',
  timeout: 300000
});

//loading对
let loading;

//当前正在请求的数量
let needLoadingRequestCount = 0;

//显示loading
function showLoading(target) {
  // 后面这个判断很重要，因为关闭时加了抖动，此时loading对象可能还存在，
  // 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
  if (needLoadingRequestCount === 0 && !loading) {
    loading = ElLoading.service({
      lock: true,
      text: 'Loading...',
      background: 'rgba(0, 0, 0, 0.7)',
      target: target || 'body'
    });
  }
  needLoadingRequestCount++;
}

//隐藏loading
function hideLoading() {
  needLoadingRequestCount--;
  needLoadingRequestCount = Math.max(needLoadingRequestCount, 0); //做个保护
  if (needLoadingRequestCount === 0) {
    //关闭loading
    toHideLoading();
  }
}

//防抖：将 300ms 间隔内的关闭 loading 便合并为一次。防止连续请求时， loading闪烁的问题。
var toHideLoading = _.debounce(() => {
  loading && loading.close();
  loading = null;
}, 300);

// 拦截器

// axios请求拦截器
httpInstance.interceptors.request.use(
    (config) => {

    // 1. 获取token
    // 2. 按照后端的要求拼接token数据
        const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    let lang = localStorage.getItem('langrage') == 'chinese' ? 'zh' : 'en';

    config.headers['Accept-Language'] = lang;
    config.headers['X-Device-Fingerprint'] = getDeviceFingerprint();
    //判断当前请求是否设置了不显示Loading
    // if (config.headers.showLoading !== false) {
    //   showLoading(config.headers.loadingTarget);
    // }
    return config;
  },
  (e) => {
    //判断当前请求是否设置了不显示Loading
    // if (config.headers.showLoading !== false) {
    //   hideLoading();
    // }
    Promise.reject(e);
  }
);

// axios响应式拦截器
httpInstance.interceptors.response.use(
  (response) => {
    //判断当前请求是否设置了不显示Loading（不显示自然无需隐藏）
    // if (response.config.headers.showLoading !== false) {
    //   hideLoading();
    // }
    const res = response.data;
    if (!res.code) return res;
    if (res.code !== 200) {
      const isRateLimited = res.code === 429;
      ElMessage({
        grouping: true,
        type: isRateLimited ? 'warning' : 'error',
        message: res.msg || `errorCode-${res.code}`
      });
      if (res.code === 401 || res.code === 403) {
        localStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          location.reload();
      }
      return Promise.reject(res.msg);
    } else {
      return res;
    }
  },
  (e) => {
    const responseData = e.response?.data;
    const isRateLimited = e.response?.status === 429;
    const message = responseData?.msg || (isRateLimited
      ? (localStorage.getItem('langrage') === 'chinese'
        ? '访问过于频繁，请稍后再试'
        : 'Too many requests. Please try again later.')
      : getFriendlyErrorMsg(e));

    ElMessage({
      grouping: true,
      type: isRateLimited ? 'warning' : 'error',
      message
    });
    return Promise.reject(e);
  }
);

const getFriendlyErrorMsg = (error) => {
  const lang = localStorage.getItem('langrage') === 'chinese' ? 'zh' : 'en';

  const messages = {
    ERR_NETWORK: {
      zh: '网络错误，请检查您的网络连接',
      en: 'Network error. Please check your internet connection.'
    },
    ECONNABORTED: {
      zh: '请求超时，请稍后再试',
      en: 'Request timeout. Please try again later.'
    },
    DEFAULT: {
      zh: '请求失败，请稍后重试',
      en: 'Request failed. Please try again later.'
    }
  };

  const code = error?.code;
  return messages[code]?.[lang] || messages.DEFAULT[lang];
};

export default httpInstance;
